import { render, staticRenderFns } from "./FatalError.vue?vue&type=template&id=185e6c6b&scoped=true&"
import script from "./FatalError.vue?vue&type=script&lang=ts&"
export * from "./FatalError.vue?vue&type=script&lang=ts&"
import style0 from "./FatalError.vue?vue&type=style&index=0&id=185e6c6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e6c6b",
  null
  
)

export default component.exports